/*
 * Copyright (C) 2026 - present Marek Kuzora - All Rights Reserved.
 */


import Entity from 'fierry/data/entity';
import Collection from 'fierry/data/collection';

import Zone from 'solis/data/board/zone';


export default class Sector extends Entity
{
  static children = [ 'zones' ];


  loadZone (cass)
  {
    return this.getZones().load(cass.id, cass);
  }


  unloadZone (cass)
  {
    this.getZones().unload(cass.id);
  }


  createZone (colonyZone)
  {
    const cass = {};

    cass.galaxy = this.cass.galaxy;
    cass.board = this.cass.board;
    cass.colony = this.cass.colony;

    cass.id = colonyZone.cass.id;
    cass.sector = colonyZone.cass.sector;

    cass.value = colonyZone.cass.value;

    cass.updateDate = this.parent.cass.updateDate;

    cass.currentUser = this.cass.currentUser;

    cass.control = [];

    return this.parent.loadZone(cass);
  }


  getZone (relativeHex)
  {
    return this.getZones().at(relativeHex);
  }


  getZones ()
  {
    return new Collection(Zone, this.cursor.child('zones'), this.parent);
  }


  getColony ()
  {
    return this.parent.getColony(this.cass.colony);
  }


  getFutureColony ()
  {
    return this.parent.getColony(this.cass.futureColony);
  }


  getBoard ()
  {
    return this.parent;
  }


};
